export const checkIsEmbeddedView = (url) => {
  const parsedUrl = new URL(url)
  const isEmbeddedView = parsedUrl.searchParams.get('isEmbeddedView') === 'true' || parsedUrl.searchParams.get('isEmbeddedView') === '1'
  return isEmbeddedView
}
